import { HttpError } from '@cash-web/shared-util-fetch'

export const catchPromise = <T>(promise: Promise<T>, onError?: (error: string | T | undefined) => void) => {
  return promise.catch(e => {
    const error = e as HttpError<T>
    const response = error.response?.body
    onError?.(response)
    if (typeof response !== 'string' && response != null) {
      return response
    }
    return {} as T
  })
}
